/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_monitoring': {
    width: 24,
    height: 20,
    viewBox: '0 0 24 20',
    data: '<defs><path pid="0" id="svgicon_icon_service_monitoring_a" d="M7.426 14L9.14 9.7 13.52 22l4.577-8H24v-3h-7.37l-2.503 4.32L9.4 2l-3.85 9H0v3z"/></defs><g transform="translate(0 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_monitoring_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_monitoring_a"/></mask><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_icon_service_monitoring_a"/><g mask="url(#svgicon_icon_service_monitoring_b)" _fill="#FF7B49"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_monitoring.js